import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fetchAdAccounts } from '../services/ml/adAccountsService';

const useAdAccounts = (userId) => {
  const [adAccounts, setAdAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAccounts = async () => {
      try { 
        if (userId) {
          const data = await fetchAdAccounts(userId);
          if (data?.data) {
            setAdAccounts(data.data);
          }
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAccounts();
  }, [userId]);

  return {
    adAccounts,
    loading,
    error,
  };
};

export default useAdAccounts;
